// services/fontteService/phone.ts - services/fontteService.ts split (sub-module phone)



export function normalizePhoneNumber(phone: string, countryCode: string = '62'): string {
    let normalized = phone.replace(/[\s\-\(\)\.]/g, '');
    if (normalized.startsWith('0')) {
        normalized = normalized.substring(1);
    }
    if (!normalized.startsWith(countryCode)) {
        normalized = countryCode + normalized;
    }
    return normalized;
}
